import { apiGlobal } from '@apis/index'
import { LOCAL_STORAGE } from '@utils/Const'
const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)

export const endPoints = {
  MAP_QUESTIONS: 'iesv/api/v1/roadmaps/questions',
  MAP_ANSWERS: 'iesv/api/v1/roadmaps/answers',
  MAP_STATUS: 'iesv/api/v1/roadmaps/users/status',
  GET_COURSES: 'iesv/api/v1/roadmaps/users/courses',
  UPDATE_CURRENT_TASK: 'iesv/api/v1/roadmaps/users/tasks',
  GET_TASK_SUMMARY: 'iesv/api/v1/roadmaps/users/tasks',
  GET_TASK_SUMMARY_OPEN: 'iesv/api/v1/open/roadmaps/users/tasks',
  GET_FEEDBACK_OVERVIEW: 'iesv/api/v1/feedbacks/users/overviews', // lấy trạng thái feedback của user
  GET_FEEDBACK_OVERVIEW_OPEN: 'iesv/api/v1/open/feedbacks/overviews',
  GET_FEEDBACK_DATA: 'iesv/api/v1/feedbacks', // lấy dữ liệu của feedback
  GET_FEEDBACK_DATA_OPEN: 'iesv/api/v1/open/feedbacks',
  GET_INPUT_PARAMS: 'iesv/api/v1/roadmaps/users/tasks',
  GET_PRE_ORDER_BANNER: 'iesv/api/v1/feedbacks/pre-order-banners/conditions',
  GET_ROADMAP_OVERVIEW: 'iesv/api/v1/roadmaps/users/overview',
  RESET_CURRENT_TASK: 'iesv/api/v1/roadmaps/reset-current-tasks',
}

const mapRequest = {
  getMapQuestions: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.MAP_QUESTIONS, {})
    }
    return apiGlobal.get(endPoints.MAP_QUESTIONS, {})
  },
  getMapStatus: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.MAP_STATUS, {})
    }
    return apiGlobal.get(endPoints.MAP_STATUS, {})
  },
  submitMapQuestions: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.MAP_ANSWERS, params)
    }
    return apiGlobal.post(endPoints.MAP_ANSWERS, params)
  },
  getCourses: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_COURSES, {})
    }
    return apiGlobal.get(endPoints.GET_COURSES, {})
  },
  getRoadmapOverview: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_ROADMAP_OVERVIEW, params)
    }
    return apiGlobal.get(endPoints.GET_ROADMAP_OVERVIEW, params)
  },
  updateCurrentTask: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPatch(
        `${endPoints.UPDATE_CURRENT_TASK}/${params.task_id}`,
        {},
      )
    }
    return apiGlobal.patch(
      `${endPoints.UPDATE_CURRENT_TASK}/${params.task_id}`,
      {},
    )
  },
  getTaskSummary: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${endPoints.GET_TASK_SUMMARY}/${params.task_id}/summaries`,
        {},
      )
    }
    return apiGlobal.get(
      `${endPoints.GET_TASK_SUMMARY_OPEN}/${params.task_id}/summaries`,
      {},
    )
  },
  getFeedbackOverview: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_FEEDBACK_OVERVIEW, {})
    }
    return apiGlobal.get(`${endPoints.GET_FEEDBACK_OVERVIEW_OPEN}`, {})
  },
  getFeedbackData: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${endPoints.GET_FEEDBACK_DATA}/${params['feedback-id']}`,
        {},
      )
    }
    return apiGlobal.get(
      `${endPoints.GET_FEEDBACK_DATA_OPEN}/${params['feedback-id']}`,
      {},
    )
  },
  getInputParams: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${endPoints.GET_INPUT_PARAMS}/${params.task_id}/IPA-input-params`,
        {},
      )
    }
    return apiGlobal.get(
      `${endPoints.GET_INPUT_PARAMS}/${params.task_id}/IPA-input-params`,
      {},
    )
  },
  getPreOrderBanner: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_PRE_ORDER_BANNER, {})
    }
    return apiGlobal.get(endPoints.GET_PRE_ORDER_BANNER, {})
  },
  resetCurrentTask: () => {
    if (getAccessToken()) {
      return apiGlobal.authPatch(endPoints.RESET_CURRENT_TASK, {})
    }
    return apiGlobal.patch(endPoints.RESET_CURRENT_TASK, {})
  },
}

export default mapRequest
